const FloneProductActionTypes = {
  FETCH_PRODUCTS_SUCCESS: "Product/FETCH_PRODUCTS_SUCCESS",
};

export default FloneProductActionTypes;
